// extracted by mini-css-extract-plugin
export default {"side-bar":"side-bar_side-bar__Rb7T7","boxShadowLight":"side-bar_boxShadowLight__9QgXf","boxShadowDark":"side-bar_boxShadowDark__FSBh6"};